var swiper = new Swiper("#br-rgtabs-1", {
	spaceBetween: 10,
	slidesPerView: 2.5,
	freeMode: true,
	watchSlidesProgress: true,
    breakpoints: {
        768: {
            slidesPerView: 3,
			allowTouchMove	: false,
		},
    }    	
});

var swiper2 = new Swiper("#br-rgtabs-2", {
	spaceBetween: 10,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	thumbs: {
		swiper: swiper,
	},
	
});